var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","overflow-x":"auto"}},[_c('div',{style:(`min-width:${_vm.minWidth}px;margin-bottom:${_vm.minWidth === '' ? '' : 10}px;`)},[_c('canvas',{attrs:{"id":_vm.chartID,"height":_vm.setHeightChart}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }